import { useState } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import MyTable from '../../../../components/MyTable';

const mapCompanyStatus = (status) => {
  if (!status) return 'N/A';
  const lower = status.toLowerCase();
  return lower === 'active' ? 'Active' : lower === 'inactive' ? 'Inactive' : status;
};

const CompanyTable = ({ data, onEditCompany, onDeleteCompany, pageSize, onPageSizeChange }) => {
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  const transformedData = data.map((company) => ({
    id: company.company_id || '',
    company: company.company || '',
    division: company.division || '',
    description: company.description || '',
    status: company.status || '',
  }));

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: { display: false },
    },
    {
      name: 'company',
      label: 'Company Code',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <h3
              onClick={() => onEditCompany(id)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {value || 'N/A'}
            </h3>
          );
        },
      },
    },
    {
      name: 'division',
      label: 'Division',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-default font-bold">{mapCompanyStatus(value)}</p>
        ),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_value, tableMeta) => {
          const companyId = tableMeta.rowData[0];
          return (
            <button
              onClick={() => setDeleteTargetId(companyId)}
              className="p-2 hover:bg-red-100 rounded-full"
              title="Delete Company"
            >
              <FiTrash2 size={16} className="text-red-500" />
            </button>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (n) => onPageSizeChange(n),
    selectableRows: 'none',
    elevation: 0,
    download: true,
    print: true,
    search: false,
    viewColumns: true,
    filter: true,
  };

  return (
    <div className="w-full overflow-x">
      <MyTable title="" data={transformedData} columns={columns} options={options} />

      {/* Delete Confirmation Dialog */}
      {deleteTargetId && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-sm flex flex-col items-center gap-4">
            <div className="flex items-center justify-center w-14 h-14 rounded-full bg-red-100 mb-2">
              <FiTrash2 size={28} className="text-red-500" />
            </div>
            <h3 className="text-lg font-bold text-gray-800 text-center">Delete Company?</h3>
            <p className="text-sm text-gray-500 text-center">
              Are you sure you want to delete this company? This action cannot be undone.
            </p>
            <div className="flex gap-3 w-full mt-2">
              <button
                onClick={() => setDeleteTargetId(null)}
                className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onDeleteCompany(deleteTargetId);
                  setDeleteTargetId(null);
                }}
                className="flex-1 py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyTable;
